// extracted by mini-css-extract-plugin
export default {"root":"ContentWithSidebar__root___rIlz6","sidebar":"ContentWithSidebar__sidebar___KgC0s","content":"ContentWithSidebar__content___tbP_i"};